<template>
  <v-row>
    <v-col
      cols="12"
      sm="6"
      offset-sm="3"
    >
      <create-team-form />
    </v-col>
  </v-row>
</template>

<script>
import i18n from '@/plugins/vue-i18n';
import CreateTeamForm from '@/components/team/CreateTeamForm';
import Layout from '@/components/shared/TheLayout';
import TabsLayout from '@/components/team/TabsLayout';

export default {
  components: {
    CreateTeamForm
  },

  layout: (h, page) => h(Layout, {
    props: {
      noWrappingContainer: true,
      pageTitle: i18n.t('Team management')
    }
  }, [h(TabsLayout, {
    props: {
      activeTab: 'create',
    }
  }, [page])]),
}
</script>